var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"#","multiple":"","list-type":_vm.listType,"accept":_vm.accept,"show-file-list":_vm.showFileList,"on-change":_vm.saveFile,"on-remove":_vm.removeFile,"file-list":_vm.fileList,"auto-upload":false}},[_vm._t("button")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }